<template>
  <transition name="slide-fade">
    <div id="app">
      <router-view></router-view>
    </div>
  </transition>
</template>

<script>
export default {
  name: "App",
  mounted() {
    // setInterval(this.$common.task,5000)
  },
};
</script>

<style lang="less">
  .contentPage {
    height: 100%;
    padding: 20px;
    .inner {
      background: #fff;
      min-height: 100%;
      padding: 25px;

      .title {
        font-size: 16px;
        color: #333333;
        position: relative;
        padding-left: 14px;

        &:before {
          content: '';
          width: 6px;
          height: 20px;
          border-radius: 20px;
          background-color: #42b935;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue